import { render, staticRenderFns } from "./manage-activity-list.component.vue?vue&type=template&id=36071167&scoped=true&"
import script from "./manage-activity-list.component.vue?vue&type=script&lang=ts&"
export * from "./manage-activity-list.component.vue?vue&type=script&lang=ts&"
import style0 from "./manage-activity-list.component.vue?vue&type=style&index=0&id=36071167&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36071167",
  null
  
)

export default component.exports